<template>
    <minimal>
        <div class="text-center">
            <p>{{t('miscellaneous.service_unavailable')}}</p>
        </div>
    </minimal>
</template>

<script setup>
import { useError } from '#imports';
const Minimal = defineAsyncComponent(() => import('~/errors/minimal.vue'))

import {useI18n} from "vue-i18n";
const { t } = useI18n();

useHead({
    title: 'Error'
})

onMounted(() => {
    const error = useError();
    throw new Error(error.value?.statusCode + ': '+error.value?.statusMessage);
});
</script>



